// /admin/:slug/day — set the airspace status + free-text note for a day.

import { useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import {
  Section, Cell, List, Button, Textarea, Caption, Banner,
} from "@telegram-apps/telegram-ui";
import { api } from "../lib/api.js";
import { usePageBack } from "../lib/telegram.js";

const STATUSES = [
  { code: "open",       icon: "✅", label: "Открыто",        note: "Без ограничений." },
  { code: "restricted", icon: "⚠️", label: "С ограничениями", note: "Опишите ограничение в заметке ниже." },
  { code: "closed",     icon: "❌", label: "Закрыто",         note: "Слотов на этот день не появится." },
];

export default function AdminDayStatus() {
  const { slug } = useParams();
  const [search] = useSearchParams();
  const navigate = useNavigate();
  usePageBack(`/admin/${slug}`);
  const date = search.get("date");
  const [status, setStatus] = useState("open");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [feedback, setFeedback] = useState(null);

  async function save() {
    setBusy(true);
    setFeedback(null);
    try {
      await api(`/api/v1/admin/airfields/${slug}/day-status`, {
        method: "POST",
        body: JSON.stringify({ date, status, note: note || null }),
      });
      setFeedback({ kind: "ok", text: "Статус сохранён." });
    } catch (e) {
      setFeedback({ kind: "err", text: e.message || "Не удалось сохранить." });
    } finally {
      setBusy(false);
    }
  }

  return (
    <List>
      <Section header={`Статус на ${date}`}>
        {STATUSES.map((s) => (
          <Cell
            key={s.code}
            onClick={() => setStatus(s.code)}
            subtitle={s.note}
            after={status === s.code ? "✓" : ""}
          >
            {s.icon} {s.label}
          </Cell>
        ))}
      </Section>

      <Section header="Заметка (видна пилотам)">
        <Cell>
          <Textarea
            placeholder="Например: ограничение через СППИ, сильный ветер по прогнозу"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </Cell>
      </Section>

      {feedback && (
        <Banner type="section" header={feedback.kind === "ok" ? "Готово" : "Ошибка"}>
          {feedback.text}
        </Banner>
      )}

      <Section>
        <Cell>
          <Button stretched mode="filled" disabled={busy} onClick={save}>
            {busy ? "Сохраняем…" : "Сохранить"}
          </Button>
        </Cell>
        <Cell>
          <Button stretched mode="plain" disabled={busy}
            onClick={() => navigate(`/admin/${slug}?date=${date}`)}>
            ← К дню
          </Button>
        </Cell>
        <Cell>
          <Caption level="1">
            Закрытые и ограниченные дни сразу подсвечиваются у пилотов в мастере бронирования и в детали слота.
          </Caption>
        </Cell>
      </Section>
    </List>
  );
}
